export default {
    data() {
        return {};
    },
    methods: {
        calculatePriceWithVat(price) {
            if (price == 0) {
                return 0;
            }
            const vat = 0.25;
            price = parseFloat(price) * (1 + vat);
            price = Math.round((price + Number.EPSILON) * 100) / 100;
            return price;
        },
        calculatePriceWithVatAndRoundToNearestTens(price) {
            if (price == 0) {
                return 0;
            }
            const vat = 0.25;
            price = parseFloat(price) * (1 + vat);
            price = Math.ceil(price / 10) * 10;
            price = price - 1;
            return price;
        },
    },
};
